import { useTranslation } from 'next-i18next';
import { observer } from 'mobx-react-lite';
import FilterBooleanState from '@features/categories/mobx/state/FilterBooleanState';
import styles from '@features/categories/components/CategoriesFilterBoolean/CategoriesFilterBoolean.styles';
import useFilterOptionValue from '@hooks/useFilterOptionValue';
import Checkbox from '@components/Checkbox/Checkbox';
type PropsType = {
  filter: FilterBooleanState;
  dropdown?: boolean;
};
const CategoriesFilterBoolean = observer(({
  filter,
  dropdown = false
}: PropsType) => {
  const {
    t
  } = useTranslation('filters');
  const {
    options,
    key
  } = filter;
  const optionsIterator = Object.keys(options);
  const getFilterOptionValue = useFilterOptionValue(options, key);
  const renderOptions = () => optionsIterator && optionsIterator.map((optionId, index) => {
    const isActive = filter.value.includes(optionId);
    const handleClick = () => {
      const newValue = isActive ? filter.value.filter(val => val !== optionId) : [...filter.value, optionId];
      filter.setValue(newValue);
    };
    return <div sx={styles.checkboxContainer} key={optionId}>
          <Checkbox value={isActive} onChange={handleClick} showError={false} addSx={styles.checkbox(dropdown, index)} cy="CategoriesFilterBooleanItem">
            {t(getFilterOptionValue(optionId))}
          </Checkbox>
        </div>;
  });
  return <div data-cy="CategoriesFilterBoolean">{renderOptions()}</div>;
});
export default CategoriesFilterBoolean;